<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item label="申请时间：" class="m-l-14">
      <el-date-picker
        v-model="filters.dateTime"
        size="small"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        unlink-panels
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        size="small"
        v-model="filters.applyType"
        placeholder="申请类型"
      >
        <el-option
          v-for="(item, i) in applyTypeAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        size="small"
        v-model="filters.contactStatus"
        placeholder="联系情况"
      >
        <el-option
          v-for="(item, i) in contactStatusAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input
        size="small"
        prefix-icon="el-icon-search"
        v-model="filters.name"
        class="m-l-14"
        placeholder="申请人姓名/联系方式"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";

export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      options: [],
      applyTypeAttr: [],
      contactStatusAttr: [],
    };
  },
  created() {
    this.getSysParamByTypes(["APPLY_TYPE", "CONTACT_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["APPLY_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["CONTACT_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.applyTypeAttr = res.data["APPLY_TYPE"];
        this.contactStatusAttr = res.data["CONTACT_STATUS"];
      });
    },
    initData() {
      let params = Object.assign({}, this.filters);
      delete params.dateTime;
      if (this.filters.dateTime) {
        params["startDate"] = this.filters.dateTime[0];
        params["endDate"] = this.filters.dateTime[1];
      }
      //查询
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
